module.exports = __webpack_public_path__ + "img/pride.fdcf25be.jpg";